<script setup lang="ts">
import {store} from '../../store/Store';

const props = defineProps<{ extraClass: string }>();

</script>

<template>
  <div :class="['container-block','container-swap-control',props.extraClass]">
    <div class="alice-ticket-centred">
      <div class="alice-ticket-hline">
        <div class="alice-ticket-invert">
          <o-icon pack="fas" icon="arrow-right-arrow-left" class="alice-ticket-invert-icon" @click="store.invertPair()"></o-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.alice-ticket-hline {
  display: block;
  width: 100%;
  height: 1px;
  margin-top: 19px;
  margin-bottom: 19px;
  transform: rotate(-360deg);
  background-color: #f2f2f3;
}

.alice-ticket-invert {
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  padding: 9px 8.8px 10px 8px;
  margin-top: -17px;
  margin-left: 47%;
  object-fit: contain;
  box-shadow: 0 0 10px 0 rgba(214, 214, 214, 0.5);
  background-color: #fbfbfc;
}

.alice-ticket-invert-icon {
  color: var(--ticket-invert-button-colour);
  margin-left: 1px;
  transform: rotate(90deg);
}
</style>